<template>
  <div class="parse-box">

    <div v-if="parseHtml" v-html="parseHtml" class="content-box">

    </div>

    <div v-if="!parseHtml" style="height:20px" class="content-box">
      <span>【解析】：</span>
      略
    </div>

    <div v-if="answerHtml">
      <span>【答案】：</span>
      <div v-html="answerHtml"></div>
    </div>

    <div v-if="!answerHtml">
      <span>【答案】：</span>
      <div>略</div>
    </div>

    <div class="question-item" v-for="(item,i) of subQuestionList" :key="item">
      <span>{{i+1}}：</span>
      <div v-html="item">
      </div>
    </div>

  </div>
</template>
 
<script>
import utils from "@/util/index";
import { getTopicParse } from "@/network/resourceRequest/api";

export default {
  name: "TopicParse",

  props: {
    //当前题目的数据
    topicData: {},
    //点击解析的盒子的id
    activeMoveBoxId: {},
    //点击题目问题的盒子id
    topicQuestionId: {},
    //图片地址前缀
    topicImgUrl: {},
  },

  data() {
    return {
      topicParseId: "",
      //根据id进一步获取题目详情
      topicParseData: {},
      //解析
      parseHtml: "",
      //答案
      answerHtml: "",
      //子题列表
      subQuestionList: [],
    };
  },

  watch: {
    //题目详情加答案
    activeMoveBoxId(newVal) {
      if (this.topicData.id == newVal && this.answerHtml == "") {
        let str, answer;
        getTopicParse(newVal).then((res) => {
          this.topicParseData = res.data.data;
          str = res.data.data.parse;
          this.parseHtml = str.replace(
            /src="\/tikuimages/g,
            `src="${this.topicImgUrl}/tikuimages`
          );
          answer = res.data.data.answer2;
          this.answerHtml = answer.replace(
            /src="\/tikuimages/g,
            `src="${this.topicImgUrl}/tikuimages`
          );
        });
      }
    },

    //题目子题
    topicQuestionId(newVal) {
      if (this.topicData.id == newVal && this.parseHtml == "") {
        getTopicParse(newVal).then((res) => {
          let str;
          res.data.data.subQuestionList.forEach((item) => {
            this.subQuestionList.push(
              item.title.replace(
                /src="\/tikuimages/g,
                `src="${this.topicImgUrl}/tikuimages`
              )
            );
          });
        });
      }
    },
  },
};
</script>
 
<style lang='less' scoped>
.parse-box {
  padding: 10px;

  .question-item {
    display: flex;
  }
}
</style>